/* eslint-disable react-hooks/exhaustive-deps */
import React, {useEffect, useState} from 'react';


import TemplatesIndex from './Index/TemplatesIndex';
import TemplatePage from './Detail/TemplatePage';


function TemplatePanel() {
  
  const [isTemplateOpen,setIsTemplateOpen] = useState(false);
  const [templateData, setTemplateData] = useState(null);

  const handleOpenNewTemplate = (data) => {
    setTemplateData(data); 
    setIsTemplateOpen(true);
  };


  return (
    isTemplateOpen ? <TemplatePage  templateData={templateData} setIsTemplateOpen={setIsTemplateOpen}/>
      : <TemplatesIndex handleOpenNewTemplate={handleOpenNewTemplate} />
     
  );
}

export default TemplatePanel;
